<div class="page">

    <!-- Main content -->
    <div class="main-content">
        <h1 class="title">Pige Express</h1>
        
        <!-- Slide and User name section -->
        <div class="slide-name-section" [formGroup]="pigeExtern">
            <div class="name-fields">
                <mat-form-field appearance="outline" class="slide-name-field">
                    <mat-label>Slide Name</mat-label>
                    <input matInput placeholder="Enter slide name" formControlName="slideName">
                </mat-form-field>
                <mat-form-field appearance="outline" class="user-name-field">
                    <mat-label>User name</mat-label>
                    <input matInput placeholder="User name (default InfluenceLab)" formControlName="userName">
                </mat-form-field>
            </div>
        </div>
        
        <!-- Loading indicator -->
        <div *ngIf="isUploading" class="loading">
            <mat-progress-spinner mode="indeterminate" diameter="32" color="primary"></mat-progress-spinner>
            <span>Uploading images...</span>
        </div>

        <!-- Content Type Accordion -->
        <mat-accordion class="accordion" multi="true" [formGroup]="pigeExtern">
            <!-- Stories Section -->
            <mat-expansion-panel 
                [expanded]="accordionState.stories" 
                (opened)="accordionState.stories = true"
                (closed)="accordionState.stories = false">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-icon>photo_library</mat-icon>
                        Stories ({{picPige.content.stories.length}})
                    </mat-panel-title>
                </mat-expansion-panel-header>
                
                <div class="section-header-actions">
                    <button mat-icon-button class="clear-section-btn" (click)="clearSection(ContentType.STORY)" 
                            [disabled]="picPige.content.stories.length === 0" 
                            matTooltip="Effacer toutes les stories">
                        <mat-icon>delete_sweep</mat-icon>
                    </button>
                </div>
                
                <div class="upload-area">
                    <mat-form-field appearance="outline" class="file-input">
                        <ngx-mat-file-input 
                            formControlName="storyFile"
                            [multiple]="true" 
                            [autofilled]="false" 
                            accept="image/*" 
                            capture="environment"
                            (change)="modifPicture($event, ContentType.STORY)" 
                            class="hide-file-names"
                            aria-label="Uploader des stories">
                        </ngx-mat-file-input>
                        <mat-icon matSuffix>attach_file</mat-icon>
                    </mat-form-field>
                    <div class="image-grid">
                        <div *ngFor="let item of picPige.content.stories; let i = index" class="image-item story-item">
                            <img [src]="'/api/picture/Images/' + item.picture" alt="Story Image">
                            <button type="button" class="delete-btn" (click)="deleteImgForModif(item.picture, item)">×</button>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>

            <!-- Reels Section -->
            <mat-expansion-panel 
                [expanded]="accordionState.reels" 
                (opened)="accordionState.reels = true"
                (closed)="accordionState.reels = false">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-icon>video_library</mat-icon>
                        Reels ({{picPige.content.reels.length}})
                    </mat-panel-title>
                </mat-expansion-panel-header>
                
                <div class="section-header-actions">
                    <button mat-icon-button class="clear-section-btn" (click)="clearSection(ContentType.REEL)" 
                            [disabled]="picPige.content.reels.length === 0" 
                            matTooltip="Effacer tous les reels">
                        <mat-icon>delete_sweep</mat-icon>
                    </button>
                </div>
                
                <div class="upload-area">
                    <mat-form-field appearance="outline" class="file-input">
                        <ngx-mat-file-input 
                            formControlName="reelFile"
                            [multiple]="true" 
                            [autofilled]="false" 
                            accept="image/*" 
                            capture="environment"
                            (change)="modifPicture($event, ContentType.REEL)" 
                            class="hide-file-names"
                            aria-label="Uploader des reels">
                        </ngx-mat-file-input>
                        <mat-icon matSuffix>attach_file</mat-icon>
                    </mat-form-field>
                </div>
                
                <div class="image-grid">
                    <div *ngFor="let item of picPige.content.reels; let i = index" class="image-item reel-item">
                        <img [src]="'/api/picture/Images/' + item.picture" alt="Reel Image">
                        <button type="button" class="delete-btn" (click)="deleteImgForModif(item.picture, item)">×</button>
                    </div>
                </div>
            </mat-expansion-panel>

            <!-- Posts Section -->
            <mat-expansion-panel 
                [expanded]="accordionState.posts" 
                (opened)="accordionState.posts = true"
                (closed)="accordionState.posts = false">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-icon>grid_on</mat-icon>
                        Posts ({{picPige.content.posts.length}})
                    </mat-panel-title>
                </mat-expansion-panel-header>
                
                <div class="section-header-actions">
                    <button mat-icon-button class="clear-section-btn" (click)="clearSection(ContentType.POST)" 
                            [disabled]="picPige.content.posts.length === 0" 
                            matTooltip="Effacer tous les posts">
                        <mat-icon>delete_sweep</mat-icon>
                    </button>
                </div>
                
                <div class="upload-area">
                    <mat-form-field appearance="outline" class="file-input">
                        <ngx-mat-file-input 
                            formControlName="postFile"
                            [multiple]="true" 
                            [autofilled]="false" 
                            accept="image/*" 
                            capture="environment"
                            (change)="modifPicture($event, ContentType.POST)" 
                            class="hide-file-names"
                            aria-label="Uploader des posts">
                        </ngx-mat-file-input>
                        <mat-icon matSuffix>attach_file</mat-icon>
                    </mat-form-field>
                </div>
                
                <div class="image-grid">
                    <div *ngFor="let item of picPige.content.posts; let i = index" class="image-item post-item">
                        <img [src]="'/api/picture/Images/' + item.picture" alt="Post Image">
                        <button type="button" class="delete-btn" (click)="deleteImgForModif(item.picture, item)">×</button>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>

        <!-- Action button -->
        <div *ngIf="getTotalImages() > 0" class="action">
            <div class="actions-row">
                <button mat-raised-button class="generate-btn" (click)="generateExpress()" [disabled]="loading">
                    <span *ngIf="!loading">Create Pige PPTX ({{getTotalImages()}} images)</span>
                    <mat-progress-spinner *ngIf="loading" mode="indeterminate" diameter="20" color="accent"></mat-progress-spinner>
                </button>
                <ng-container *ngIf="exportFile && exportFileUP">
                    <a *ngFor="let exportFile of exportArrayFiles" [href]="exportFile">
                        <button mat-raised-button class="generate-btn">
                            <mat-icon>download</mat-icon>
                            Download
                        </button>
                    </a>
                </ng-container>
                <button mat-raised-button class="clear-all-btn" (click)="clearAll()" 
                        matTooltip="Effacer toutes les images">
                    <mat-icon>delete_sweep</mat-icon>
                    Clear All
                </button>
            </div>
        </div>
    </div>
</div>